import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const OrgContext = createContext(null);

export function OrgProvider({ children }) {
  const { user, isAmden } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [orgId, setOrgIdState] = useState(null);
  const [loading, setLoading] = useState(true);

  const setOrgId = useCallback((id) => {
    setOrgIdState(id);
    if (id) localStorage.setItem("amden_org", id);
  }, []);

  const clearOrg = useCallback(() => {
    setOrgIdState(null);
    localStorage.removeItem("amden_org");
  }, []);

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    api
      .get("/organisations")
      .then((r) => {
        setOrgs(r.data);
        if (!isAmden && user.organisation_id) {
          setOrgIdState(user.organisation_id);
        } else {
          const saved = localStorage.getItem("amden_org");
          if (saved && r.data.some((o) => o.id === saved)) setOrgIdState(saved);
        }
      })
      .finally(() => setLoading(false));
  }, [user, isAmden]);

  const currentOrg = orgs.find((o) => o.id === orgId) || null;

  return (
    <OrgContext.Provider value={{ orgs, orgId, setOrgId, clearOrg, currentOrg, loading, setOrgs }}>
      {children}
    </OrgContext.Provider>
  );
}

export const useOrg = () => useContext(OrgContext);
